import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'lin-add-note-dialog',
  templateUrl: './add-note-dialog.component.html',
  styleUrls: ['./add-note-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddNoteDialogComponent {
  notelValue = new FormControl('')
}
